<template>
  <div style="margin-top: 113px">
    <v-container>
      <v-card>
        <v-snackbar
          v-model="snackbar"
          :color="snackBarColor"
          :timeout="snackBarTimeout"
        >
          <b>{{ snackBarText }} </b>
        </v-snackbar>

        <div class="my-2">
          <v-btn
            small
            class="mx-6 my-6"
            fab
            dark
            color="warning"
            v-on:click="$router.go(-1)"
          >
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
        </div>
        <v-card-title>
          Adding a new user
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valider" lazy-validation>
            <v-text-field
              v-model="myUser.registrationNumber"
              label="Europcar Id"
              required
            ></v-text-field>
            <v-text-field
              v-model="myUser.firstName"
              label="First Name"
              required
            ></v-text-field>
            <v-text-field
              v-model="myUser.lastName"
              label="Last Name"
              required
            ></v-text-field>
            <v-text-field
              v-model="myUser.login"
              label="Login"
              required
              :rules="notificationAchievementRules"
            ></v-text-field>
            <v-text-field
              v-model="myUser.jobTitle"
              label="Job title"
              required
            ></v-text-field>
            <v-select
              v-model="myUser.company.code"
              :items="refCompanies"
              label="Company"
              item-text="label"
              item-value="code"
              required
            ></v-select>
            <v-select
              :items="refCountries"
              v-model="myUser.workingCountry.code"
              item-text="label"
              item-value="code"
              label="Perimeter"
            ></v-select>
            <v-select
              v-model="myUser.langue"
              :items="refLangue"
              label="Display Language"
              item-text="label"
              item-value="code"
              required
            ></v-select>
            <v-select
              v-model="myUser.businessUnit.code"
              :items="refBusinessUnits"
              label="Business Unit"
              item-text="label"
              item-value="code"
              required
            ></v-select>
            <v-menu :close-on-content-click="false">
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="myUser.companyEntryDate"
                  label="Entry Date"
                  v-on="on"
                  :rules="entryDateRules"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="myUser.companyEntryDate"
                color="#00635b"
              ></v-date-picker>
            </v-menu>
            <v-select
              v-model="myUser.groupFunction.code"
              :items="refGroupFunctions"
              @change="refSubGroupFunctionsUpdate()"
              label="Group function"
              item-text="label"
              item-value="code"
              required
            ></v-select>
            <v-select
              v-model="myUser.locationCountry.code"
              :items="refLocationCountry"
              label="Location Country"
              item-text="label"
              item-value="code"
              required
            ></v-select>
            <v-text-field
              v-model="myUser.locationCity"
              label="Location City"
              required
            ></v-text-field>
            <v-select
              v-model="myUser.employers.code"
              :items="refEmployer"
              label="Employer"
              item-text="label"
              item-value="code"
              required
              :rules="notificationAchievementRules"
            ></v-select>
            Strong line manager : {{ myUser.slm.firstName }}
            {{ myUser.slm.lastName }} ({{ myUser.slm.jobTitle }})
            <v-divider></v-divider>
            <v-autocomplete
              v-model="slmanager"
              :items="itemsForSLM"
              :loading="isLoadingForSLM"
              :search-input.sync="searchForSLM"
              color="white"
              hide-no-data
              hide-selected
              item-text="Description"
              item-value="SLM"
              label="Strong line manager"
              placeholder="Start typing to search"
              prepend-icon="mdi-database-search"
              return-object
              :rules="slManagerValidationRules"
            ></v-autocomplete>
            <v-btn
              depressed
              small
              color="primary"
              @click="
                slmanager = null;
                myUser.slmanager.id = null;
                myUser.slmanager.firstName = '';
                myUser.slmanager.lastName = '';
              "
              class="ma-4"
            >
              Reset strong line manager
            </v-btn>
            <v-divider></v-divider>
            Dotted line manager : {{ myUser.dlm.firstName }}
            {{ myUser.dlm.lastName }} ({{ myUser.dlm.jobTitle }})
            <v-divider></v-divider>
            <v-autocomplete
              v-model="dlmanager"
              :items="itemsForDLM"
              :loading="isLoadingForSLM"
              :search-input.sync="searchForDLM"
              color="white"
              hide-no-data
              hide-selected
              item-text="Description"
              item-value="DLM"
              label="Dotted line manager"
              placeholder="Start typing to search"
              prepend-icon="mdi-database-search"
              return-object
              :rules="slManagerValidationRules"
            ></v-autocomplete>
            <v-btn
              depressed
              small
              color="primary"
              @click="
                dlmanager = null;
                myUser.dlmanager.id = null;
                myUser.dlmanager.firstName = '';
                myUser.dlmanager.lastName = '';
              "
              class="ma-4"
            >
              Reset dotted line manager
            </v-btn>
            <br />
            Notes
            <v-textarea
              maxlength="800"
              class="mt-3 mb-3"
              label="Notes"
              hide-details
              v-model="myUser.managersComments"
              outlined
              auto-grow
              row-height="2"
            ></v-textarea>

            <v-divider></v-divider>
            Delegate : {{ myUser.delegate.firstName }}
            {{ myUser.delegate.lastName }} ({{ myUser.delegate.jobTitle }})
            <v-divider></v-divider>
            <v-autocomplete
              v-model="delegate"
              :items="itemsForDelegate"
              :loading="isLoadingForDelegate"
              :search-input.sync="searchForDelegate"
              color="white"
              hide-no-data
              hide-selected
              item-text="Description"
              item-value="Delegate"
              label="Delegate"
              placeholder="Start typing to search"
              prepend-icon="mdi-database-search"
              return-object
            ></v-autocomplete>
            <v-btn
              depressed
              small
              color="primary"
              @click="
                delegate = null;
                myUser.delegate.id = null;
                myUser.delegate.firstName = '';
                myUser.delegate.lastName = '';
              "
              class="ma-4"
            >
              Reset delegate
            </v-btn>
            <v-divider></v-divider>
            <v-checkbox
              value="TOP"
              v-model="myUser.top"
              label="TOP"
            ></v-checkbox>
            <v-checkbox
              v-model="myUser.workInFrance"
              label="Concerned by Entretien Pro and Bilan"
            ></v-checkbox>
            <v-divider></v-divider>
            <v-btn color="success" class="mr-4" @click="validate">
              Validate
            </v-btn>
            <v-btn color="warning" @click="resetForm">
              Reset
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AdminUserAdd",

  data() {
    return {
      // form validation
      valider: true,
      notificationAchievementRules: [
        (v) => v != null || "This field is required",
        (v) => v !== "" || "This field is required",
      ],
      slManagerValidationRules: [
        (v) => {
          console.log(v);
          if (this.slmanager && this.dlmanager && this.slmanager === this.dlmanager) {

            return "SL Manager and DL Manager can't be the same person";
          }
          return true;
        },
      ],

      entryDateRules: [
        (v) => {
          if (v == null || v == "") {
            return true;
          }
          //check if date format is yyyy-mm-dd
          var matches = v.match(
            /^(19|20)\d\d[-](0[1-9]|1[012])[-](0[1-9]|[12][0-9]|3[01])$/
          );
          if (matches == null) {
            return "Entry date must be in the format yyyy-mm-dd";
          }
          return true;
        },
      ],

      // [START] Data for autocomplete search
      descriptionLimit: 60,
      entriesForSLM: [],
      entriesForDLM: [],
      entriesForDelegate: [],
      myUser: {
        businessUnit: {},
        company: {},
        groupFunction: {},
        workingCountry: {},
        slm: {},
        dlm: {},
        delegate: {},
        locationCountry: {},
        employers: {},
      },
      isLoadingForSLM: false,
      isLoadingForDLM: false,
      isLoadingForDelegate: false,
      slmanager: null,
      dlmanager: null,
      delegate: null,
      searchForSLM: null,
      searchForDLM: null,
      searchForDelegate: null,
      countForSLM: 0,
      countForDLM: 0,
      countForDelegate: 0,
      // [END] Data for autocomplete search
      findByName: "",
      refBusinessUnits: [],
      refCompanies: [],
      refGroupFunctions: [],
      refSubGroupFunctions: [],
      refSubGroupFunctionsCurrent: [],
      refCountries: [],
      refLocationCountry: [],
      refEmployer: [],
      refLangue: [],
      snackbar: false,
      snackBarText: "",
      snackBarColor: "",
      snackBarTimeout: 2000,
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      perimeterAdmin: "auth/perimeterAdmin",
      userHasRoleAdmin: "auth/userHasRoleAdmin",
    }),
    itemsForSLM() {
      return this.entriesForSLM.map(
        (element) => element.firstName + " " + element.lastName
      );
    },
    itemsForDLM() {
      return this.entriesForDLM.map(
        (element) => element.firstName + " " + element.lastName
      );
    },
    itemsForDelegate() {
      return this.entriesForDelegate.map(
        (element) => element.firstName + " " + element.lastName
      );
    },
  },
  watch: {
    searchForSLM(val) {
      // Items have already been loaded

      // Items have already been requested
      if (this.isLoadingForSLM) return;

      this.isLoadingForSLM = true;

      // Lazily load input items
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(
        process.env.VUE_APP_ROOT_API_PATH + "api/usersWithName?name=" + val,
        {
          method: "GET",
          credentials: "include",
          headers: myHeaders,
        }
      )
        .then((res) => res.json())
        .then((res) => {
          this.countForSLM = res.data.length;
          this.entriesForSLM = res.data;
        })
        .finally(() => (this.isLoadingForSLM = false));
    },
    searchForDLM(val) {
      // Items have already been loaded

      // Items have already been requested
      if (this.isLoadingForDLM) return;

      this.isLoadingForDLM = true;

      // Lazily load input items
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(
        process.env.VUE_APP_ROOT_API_PATH + "api/usersWithName?name=" + val,
        {
          method: "GET",
          credentials: "include",
          headers: myHeaders,
        }
      )
        .then((res) => res.json())
        .then((res) => {
          this.countForDLM = res.data.length;
          this.entriesForDLM = res.data;
        })
        .finally(() => (this.isLoadingForDLM = false));
    },
    searchForDelegate(val) {
      // Items have already been loaded

      // Items have already been requested
      if (this.isLoadingForDelegate) return;

      this.isLoadingForDelegate = true;

      // Lazily load input items
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(
        process.env.VUE_APP_ROOT_API_PATH + "api/usersWithName?name=" + val,
        {
          method: "GET",
          credentials: "include",
          headers: myHeaders,
        }
      )
        .then((res) => res.json())
        .then((res) => {
          this.countForDelegate = res.data.length;
          this.entriesForDelegate = res.data;
        })
        .finally(() => (this.isLoadingForDelegate = false));
    },
  },
  mounted: function() {
    this.init();
  },
  methods: {
    selectedSLM(count, list) {
      let selectedSLM = "";
      for (var i = 0; i < count; i++) {
        selectedSLM = list[i].firstName + " " + list[i].lastName;
        if (selectedSLM == this.searchForSLM) {
          return (list[0] = list[i]);
        }
      }
    },
    selectedDLM(count, list) {
      let selectedDLM = "";
      for (var i = 0; i < count; i++) {
        selectedDLM = list[i].firstName + " " + list[i].lastName;
        if (selectedDLM == this.searchForDLM) {
          return (list[0] = list[i]);
        }
      }
    },
    selectedDelegate(count, list) {
      let selectedDelegate = "";
      for (var i = 0; i < count; i++) {
        selectedDelegate = list[i].firstName + " " + list[i].lastName;
        if (selectedDelegate == this.searchForDelegate) {
          return (list[0] = list[i]);
        }
      }
    },
    init: function() {
      this.loadRefs();
    },
    loadRefs: function() {
      this.fillBusinessUnits();
      this.fillGroupFunctions();
      this.fillCompanies();
      this.fillCountries();
      this.fillLanguages();
      this.fillLocationCountrys();
      this.fillEmployers();
    },
    fillBusinessUnits: function() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/ref/businessUnits", {
        method: "GET",
        credentials: "include",
        headers: myHeaders,
      })
        .then((response) => {
          if (response.status == "200" || response.status == "201") {
            this.messageType = "success";
            return response.json();
          } else {
            this.message = "An error happened, please try again later";
            this.messageType = "error";
          }
          this.showMessage = true;
        })
        .then((json) => {
          this.refBusinessUnits = json.data;
        })
        .catch(() => {
          this.message = "An error occurs, please try again later";
          this.messageType = "error";
          this.showMessage = true;
        });
    },
    fillLanguages: function() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(process.env.VUE_APP_ROOT_API_PATH + "api-public/ref/languages", {
        method: "GET",
        credentials: "include",
        headers: myHeaders,
      })
        .then((response) => {
          if (response.status == "200" || response.status == "201") {
            this.messageType = "success";
            return response.json();
          } else {
            this.message = "An error happened, please try again later";
            this.messageType = "error";
          }
          this.showMessage = true;
        })
        .then((json) => {
          this.refLangue = json.data;
        })
        .catch(() => {
          this.message = "An error occurs, please try again later";
          this.messageType = "error";
          this.showMessage = true;
        });
    },
    fillCountries: function() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/ref/countries", {
        method: "GET",
        credentials: "include",
        headers: myHeaders,
      })
        .then((response) => {
          if (response.status == "200" || response.status == "201") {
            this.messageType = "success";
            return response.json();
          } else {
            this.message = "An error happened, please try again later";
            this.messageType = "error";
          }
          this.showMessage = true;
        })
        .then((json) => {
          if (this.perimeterAdmin !== "all") {
            let valueToCompare = this.perimeterAdmin.split(",");
            json.data.forEach((element) => {
              valueToCompare.forEach((element1) => {
                if (element.code == element1) {
                  this.refCountries.push(element);
                }
              });
            });
          } else {
            this.refCountries = json.data;
          }
        })
        .catch(() => {
          this.message = "An error occurs, please try again later";
          this.messageType = "error";
          this.showMessage = true;
        });
    },
    fillCompanies: function() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/ref/companies", {
        method: "GET",
        credentials: "include",
        headers: myHeaders,
      })
        .then((response) => {
          if (response.status == "200" || response.status == "201") {
            this.messageType = "success";
            return response.json();
          } else {
            this.message = "An error happened, please try again later";
            this.messageType = "error";
          }
          this.showMessage = true;
        })
        .then((json) => {
          this.refCompanies = json.data;
        })
        .catch(() => {
          this.message = "An error occurs, please try again later";
          this.messageType = "error";
          this.showMessage = true;
        });
    },
    fillGroupFunctions: function() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/ref/groupFunctions", {
        method: "GET",
        credentials: "include",
        headers: myHeaders,
      })
        .then((response) => {
          if (response.status == "200" || response.status == "201") {
            this.messageType = "success";
            return response.json();
          } else {
            this.message = "An error happened, please try again later";
            this.messageType = "error";
          }
          this.showMessage = true;
        })
        .then((json) => {
          this.refGroupFunctions = json.data;
        })
        .catch(() => {
          this.message = "An error occurs, please try again later";
          this.messageType = "error";
          this.showMessage = true;
        });
    },
    fillLocationCountrys: function() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/ref/locationCountrys", {
        method: "GET",
        credentials: "include",
        headers: myHeaders,
      })
        .then((response) => {
          if (response.status == "200" || response.status == "201") {
            this.messageType = "success";
            return response.json();
          } else {
            this.message = "An error happened, please try again later";
            this.messageType = "error";
          }
          this.showMessage = true;
        })
        .then((json) => {
          this.refLocationCountry = json.data;
        })
        .catch(() => {
          this.message = "An error occurs, please try again later";
          this.messageType = "error";
          this.showMessage = true;
        });
    },
    fillEmployers: function() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/ref/employers", {
        method: "GET",
        credentials: "include",
        headers: myHeaders,
      })
        .then((response) => {
          if (response.status == "200" || response.status == "201") {
            this.messageType = "success";
            return response.json();
          } else {
            this.message = "An error happened, please try again later";
            this.messageType = "error";
          }
          this.showMessage = true;
        })
        .then((json) => {
          this.refEmployer = json.data;
        })
        .catch(() => {
          this.message = "An error occurs, please try again later";
          this.messageType = "error";
          this.showMessage = true;
        });
    },
    validate: function() {
      if (this.entriesForSLM[0] && this.entriesForDLM[0] && this.entriesForSLM[0].id === this.entriesForDLM[0].id) {
        this.snackbar = true;
        this.snackBarText = "SL Manager and DL Manager can’t be the same person";
        this.snackBarColor = "error";
        return;
      }
      if (this.$refs.form.validate()) {
        if (this.entriesForSLM[0]) {
          this.selectedSLM(this.countForSLM, this.entriesForSLM);
          this.myUser.slm = this.entriesForSLM[0];
        } else {
          this.myUser.slm = {};
        }
        if (this.entriesForDLM[0]) {
          this.selectedDLM(this.countForDLM, this.entriesForDLM);
          this.myUser.dlm = this.entriesForDLM[0];
        } else {
          this.myUser.dlm = {};
        }
        if (this.entriesForDelegate[0]) {
          this.selectedDelegate(this.countForDelegate, this.entriesForDelegate);
          this.myUser.delegate = this.entriesForDelegate[0];
        } else {
          this.myUser.delegate = {};
        }
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var myMethod = "post";

        fetch(process.env.VUE_APP_ROOT_API_PATH + "api/users/", {
          method: myMethod,
          credentials: "include",
          headers: myHeaders,
          body: JSON.stringify(this.myUser),
        })
          .then((response) => {
            return response.json();
          })
          .then((json) => {
            this.snackbar = true;
            if (json.status == "200" || json.status == "201") {
              this.snackBarText = "Saved successfully";
              this.snackBarColor = "success";
              this.$router.push("/adminuser?add=ok");
            } else {
              this.snackBarText = "Something went wrong : " + json.message;
              this.snackBarColor = "error";
              //          this.init();
            }
          });
      } else {
        this.snackbar = true;
        this.snackBarText = "Please fill in the missing fields";
        this.snackBarColor = "error";
      }
    },
    resetForm: function() {
      Object.assign(this.$data, this.$options.data.call(this));
      this.init();
    },
    refSubGroupFunctionsUpdate: function() {
      var codegf = this.myUser.groupFunction.code;
      this.refSubGroupFunctionsCurrent = [];
      this.refSubGroupFunctions.forEach((element) => {
        if (element.refGroupFunctionDto.code == codegf) {
          this.refSubGroupFunctionsCurrent.push(element);
        }
      });
    },
  },
};
</script>
